__webpack_require__.p = "https://documents.nakawavtc.ac.ug/";